// Capa de tiles DESACOPLADA de la lógica de Transformart Delivery.
// Cambiar de proveedor = cambiar solo esta config, sin tocar mapa/cotización/servicios.
// CARTO Dark Matter requiere API key (REACT_APP_CARTO_API_KEY en frontend/.env).
// Si no hay key, se usa OpenStreetMap estándar (sin key) como respaldo para el MVP.

const CARTO_KEY = process.env.REACT_APP_CARTO_API_KEY;

export const TILE_CONFIG = CARTO_KEY
  ? {
      provider: "carto",
      url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?api_key={apikey}".replace(
        "{apikey}",
        CARTO_KEY
      ),
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: "abcd",
      needsDarkFilter: false,
    }
  : {
      provider: "osm",
      url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      subdomains: "abc",
      needsDarkFilter: true, // OSM es claro; se oscurece por CSS sin alterar el tile
    };
